// extracted by mini-css-extract-plugin
module.exports = {"item":"ParticipantInput_item__3f50D","highlighted":"ParticipantInput_highlighted__1lh9j","details":"ParticipantInput_details__3xQlE","name":"ParticipantInput_name__150s7"};